module.exports = __webpack_public_path__ + "static/media/whatsapp.f1815c5b.svg";